import { __assign } from "tslib";
import React, { useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Tooltip } from '@keen.io/ui-core';
import { useTooltip } from '@keen.io/react-hooks';
import { ChartBase, Grid, Axes } from '../../components';
import Bubbles from './bubbles.component';
import TooltipContent from './tooltip-content.component';
import { generateBubbles } from './utils';
import { useDynamicChartLayout } from '../../hooks';
import { theme as defaultTheme } from '../../theme';
import { DEFAULT_MARGINS } from './constants';
var tooltipMotion = {
    transition: { duration: 0.3 },
    exit: { opacity: 0 },
};
export var BubbleChart = function (_a) {
    var data = _a.data, svgDimensions = _a.svgDimensions, _b = _a.useDynamicLayout, useDynamicLayout = _b === void 0 ? true : _b, xDomainKey = _a.xDomainKey, yDomainKey = _a.yDomainKey, labelSelector = _a.labelSelector, _c = _a.disabledKeys, disabledKeys = _c === void 0 ? [] : _c, valueKey = _a.valueKey, _d = _a.theme, theme = _d === void 0 ? defaultTheme : _d, _e = _a.margins, margins = _e === void 0 ? DEFAULT_MARGINS : _e, _f = _a.maxAreaRadius, maxAreaRadius = _f === void 0 ? 40 : _f, _g = _a.minAreaRadius, minAreaRadius = _g === void 0 ? 5 : _g, _h = _a.xScaleSettings, xScaleSettings = _h === void 0 ? { type: 'linear' } : _h, _j = _a.yScaleSettings, yScaleSettings = _j === void 0 ? { type: 'linear' } : _j, xAxisTitle = _a.xAxisTitle, yAxisTitle = _a.yAxisTitle, formatTooltip = _a.formatTooltip;
    var _k = useDynamicChartLayout(useDynamicLayout, margins), layoutMargins = _k.layoutMargins, layoutReady = _k.layoutReady, setLayoutReady = _k.setLayoutReady, setLayoutMargins = _k.setLayoutMargins;
    var _l = generateBubbles({
        data: data,
        margins: layoutMargins,
        maxAreaRadius: maxAreaRadius,
        minAreaRadius: minAreaRadius,
        valueKey: valueKey,
        dimension: svgDimensions,
        labelSelector: labelSelector,
        disabledKeys: disabledKeys,
        xDomainKey: xDomainKey,
        yDomainKey: yDomainKey,
        colors: theme.colors,
    }), bubbles = _l.bubbles, xScale = _l.xScale, yScale = _l.yScale, middlePoint = _l.middlePoint;
    var svgElement = useRef(null);
    var tooltipRef = useRef(null);
    var _m = useTooltip(svgElement, false, false, tooltipRef), tooltipVisible = _m.tooltipVisible, tooltipPosition = _m.tooltipPosition, tooltipSelectors = _m.tooltipSelectors, updateTooltipPosition = _m.updateTooltipPosition, hideTooltip = _m.hideTooltip;
    var tooltipSettings = theme.tooltip;
    return (React.createElement(React.Fragment, null,
        React.createElement(AnimatePresence, null, tooltipVisible && (React.createElement(motion.div, __assign({}, tooltipMotion, { initial: { opacity: 0, x: tooltipPosition.x, y: tooltipPosition.y }, animate: {
                x: tooltipPosition.x,
                y: tooltipPosition.y,
                opacity: 1,
            }, style: {
                position: 'absolute',
                pointerEvents: 'none',
            }, ref: tooltipRef }),
            React.createElement(Tooltip, { mode: tooltipSettings.mode, hasArrow: false }, tooltipSelectors && (React.createElement(TooltipContent, { data: data, labelSelector: labelSelector, selectors: tooltipSelectors, typography: tooltipSettings.labels.typography, valueKey: valueKey, xDomainKey: xDomainKey, yDomainKey: yDomainKey, formatValue: formatTooltip })))))),
        React.createElement(ChartBase, { ref: svgElement, theme: theme, svgDimensions: svgDimensions, margins: layoutMargins, xScaleSettings: xScaleSettings, yScaleSettings: yScaleSettings },
            React.createElement(Axes, { svgElement: svgElement, useDynamicLayout: useDynamicLayout, initialMargins: margins, onComputeLayout: function (margins) {
                    setLayoutMargins(margins);
                    setLayoutReady(true);
                }, xScale: xScale, yScale: yScale, xTitle: xAxisTitle, yTitle: yAxisTitle }),
            layoutReady && (React.createElement(React.Fragment, null,
                React.createElement(Grid, { xScale: xScale, yScale: yScale }),
                React.createElement(Bubbles, { bubbles: bubbles, middlePoint: middlePoint, onMouseEnter: function (e, selectors) {
                        if (tooltipSettings.enabled) {
                            updateTooltipPosition(e, selectors);
                        }
                    }, onMouseLeave: function () {
                        hideTooltip();
                    } }))))));
};
export default BubbleChart;
